import { ReactNode, useCallback, useEffect, useMemo, useRef } from 'react'
import CandleChangeManager, { CandleChangeProps } from './candleChangeManager'
import { CandleChangeManagerContext } from './candleChangeManagerContext'

interface CandleChangeManagerProviderProps extends CandleChangeProps {
    children: ReactNode;
}

export const CandleChangeManagerProvider: React.FC<CandleChangeManagerProviderProps> = ({
                                                                                            children,
                                                                                            ...props
                                                                                        }) => {
    const manager = useRef(new CandleChangeManager(props))

    const cleanup = useCallback(() => {
        if (manager.current) {
            manager.current.destroy()
        }
    }, [])

    useEffect(() => {
        return () => {
            cleanup()
        }
    }, [])

    useEffect(() => {
        if (manager.current) {
            manager.current.tradingSessions = props.tradingSessions
        }
    }, [props.tradingSessions])

    useEffect(() => {
        manager.current?.setWebSocket(props.ws)
    }, [props.ws])

    useEffect(() => {
        if (manager.current) {
            manager.current.onCandleChangeCallbackChange(props.onCandleChangeCallback)
        }
    }, [props.onCandleChangeCallback])

    const value = useMemo(() => ({ manager: manager.current }), [])

    return (
        <CandleChangeManagerContext.Provider value={value}>
            {children}
        </CandleChangeManagerContext.Provider>
    )
}
